export const getIsActionLoading = (isAdding: boolean, isRemoving: boolean): boolean =>
  isAdding || isRemoving;

export const getIsDisabled = (isCheckingFavorite: boolean, isActionLoading: boolean): boolean =>
  isCheckingFavorite || isActionLoading;
